<div class="dx-card wide-card">
    <h4 class="content-block ap-green">O2 ASU Awards by Application</h4>

    <div class="content-block">
        <o2-report-filters (viewReport)="getO2PortalAwardsByApplication($event)"></o2-report-filters>
        <dx-responsive-box singleColumnScreen="xs sm md">
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-col [ratio]=".5"></dxi-col>
            <dxi-col [ratio]=".5"></dxi-col>
            <dxi-item>
                <dxi-location [row]="0" [col]="0" [colspan]="2"></dxi-location>
                <h4 class="lblmargin ap-green">Historical Awards: {{fromDate}} - {{toDate}}</h4>
                <div class="btndiv">
                    <dx-button icon="export" text="Export Charts" type="default" [width]="160"
                        (onClick)="exportCharts()">
                    </dx-button>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="1" [col]="0"></dxi-location>
                <h4 class="lblmargin" style="text-align: center;">Volume Analysis by Application</h4>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="2" [col]="0"></dxi-location>
                <dx-pie-chart palette="soft" [resolveLabelOverlapping]="resolveOverlappingTypes[0]" id="dxPieChart"
                    [dataSource]="o2PortalAwardsByApplicationPieChartData">
                    <dxi-series argumentField="application" valueField="cumulativePercent">
                        <dxo-label [customizeText]="customizeLabel" [visible]="true">
                            <dxo-connector [visible]="true" [width]="1"></dxo-connector>
                        </dxo-label>
                    </dxi-series>
                    <dxo-size [width]="500"></dxo-size>
                </dx-pie-chart>
            </dxi-item>
            <dxi-item class="marginL30">
                <dxi-location [row]="2" [col]="1"></dxi-location>
                <dx-chart [customizePoint]="customizePoint" class="width100" #dxApplicationBarChart
                    id="dxApplicationBarChart" [dataSource]="o2PortalAwardsByApplicationBarChartData">
                    <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                    <dxo-common-series-settings argumentField="awardYear" valueField="totalOxygen" type="stackedBar">
                    </dxo-common-series-settings>
                    <dxi-value-axis position="left">
                        <dxo-title text="Total O2 (mtpd)"></dxo-title>
                    </dxi-value-axis>
                    <dxo-legend verticalAlignment="top" horizontalAlignment="center" [visible]="false">
                    </dxo-legend>
                    <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip">
                        <dxo-format type="thousands" [precision]="1">
                        </dxo-format>
                    </dxo-tooltip>
                    <dxo-argument-axis [allowDecimals]="false">
                    </dxo-argument-axis>
                    <dxo-series-template nameField="application"></dxo-series-template>
                    <dxo-scroll-bar [visible]="false"></dxo-scroll-bar>
                </dx-chart>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="3" [col]="0"></dxi-location>
                <label class="label-text">{{totalGaseousOxygenText}}</label>
            </dxi-item>
        </dx-responsive-box>
        <hr />
        <div class="btndiv">
            <dx-button icon="export" text="Export Grid" type="default" [width]="145" (onClick)="exportExcel($event)">
            </dx-button>
        </div>
        <div class="marginT15">
            <h4 class="lblmargin ap-green">Volume Analysis By Application & Competitor</h4>
            <dx-pivot-grid class="grdmargin" #VolumeAnalysisByApplicationAndCompetitor
                id="VolumeAnalysisByApplicationAndCompetitor" [allowSortingBySummary]="true" [allowFiltering]="false"
                (onCellPrepared)="onCellPrepared($event)" [showBorders]="true" [showColumnGrandTotals]="true"
                [showRowGrandTotals]="true" [showRowTotals]="true" [showColumnTotals]="false"
                [dataSource]="pivotGridApplicationAndCompititorDataSource">
                <dxo-field-chooser [enabled]="false" [height]="400"></dxo-field-chooser>
                <dxo-scrolling mode="virtual"></dxo-scrolling>
            </dx-pivot-grid>
        </div>

        <div class="marginT15">
            <h4 class="lblmargin ap-green">Volume Analysis By Application & Region</h4>
            <dx-pivot-grid class="grdmargin" #VolumeAnalysisByApplicationAndRegion
                id="VolumeAnalysisByApplicationAndRegion" [allowSortingBySummary]="true" [allowFiltering]="false"
                (onCellPrepared)="onCellPrepared($event)" [showBorders]="true" [showColumnGrandTotals]="true"
                [showRowGrandTotals]="true" [showRowTotals]="true" [showColumnTotals]="false"
                [dataSource]="pivotGridApplicationAndRegionDataSource">
                <dxo-field-chooser [enabled]="false" [height]="400"></dxo-field-chooser>
                <dxo-scrolling mode="virtual"></dxo-scrolling>
            </dx-pivot-grid>
        </div>
    </div>
</div>